export const textToPdf = async (data: string, name: string): Promise<void> => {
  if (!document) return

  const link = document.createElement('a')
  link.href = `data:application/pdf;base64,${data}`
  link.download = `${name}.pdf`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
